import { configureBudgetStyles } from "@insite/content-library/Widgets/Budget/ConfigureBudget";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

configureBudgetStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important;
        /* &:hover {
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("text.accent")} !important;
    } */

        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            /* background: ${getColor("text.accent")}; */
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            opacity: 0.3;
            background: none !important;

            /* span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
       
    } */
        }
    `,
};
configureBudgetStyles.saveButton = {
    css: css`
        margin-left: 10px;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
    `,
};
configureBudgetStyles.gridItems = {
    width: [12, 12, 6, 6, 6],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    overflow: auto;
                    white-space: nowrap;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
configureBudgetStyles.periodHeader = {
    css: css`
        white-space: nowrap !important;
    `,
};
configureBudgetStyles.budgetYearEndDatePicker = {
    cssOverrides: {
        formField: css`
            .react-calendar {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            overflow: auto;
                            height: 277px;
                        `,
                        css`
                            overflow: auto;
                            height: 277px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            div[class^="FormInputWrapper"] {
                margin-top: 10px !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: auto;
                        margin-right: 35px;
                        margin-top: 15px;
                    `,
                    css`
                        width: auto;
                        margin-right: 35px;
                        margin-top: 15px;
                    `,
                    css`
                        width: auto;
                        margin-right: 35px;
                    `,
                    css`
                        width: auto;
                        margin-right: 35px;
                    `,
                    css`
                        width: auto;
                        margin-right: 35px;
                    `,
                ])}
        `,
        datePicker: css`
            div[class^="react-datetime-picker__inputGroup"] {
                height: 38px;
            }
        `,
    },
    labelProps: {
        css: css`
            margin-bottom: 3px;
        `,
    },
};
